import IconCpu from '@/components/icons/IconCpu.vue'

import i18n from '@/i18n'

import { DEFAULT_COLOR } from './color.config.js'

/** Sentinel value for the synthetic "System" option in dropdowns and filters. */
export const SYSTEM_VALUE = '__system__'

/** System row with cpu icon (category filters). */
export const SYSTEM_FILTER_OPTION = Object.freeze({
  value: SYSTEM_VALUE,
  label: i18n.global.t('common.system'),
  color: DEFAULT_COLOR,
  system: true,
  icon: IconCpu,
})

/** Synthetic dropdown row when a stored id is the system category. */
export function systemCategoryOption(category, { icon = false } = {}) {
  const row = {
    value: category._id,
    label: i18n.global.t('common.system'),
    color: category.color ?? DEFAULT_COLOR,
    system: true,
  }
  if (icon) row.icon = IconCpu
  return Object.freeze(row)
}
